import React from "react"

const HorizontalScrollable = ({ children, className, childClassName }) => (
  <div
    className={className}
    style={{
      WebkitOverflowScrolling: "touch",
      display: "flex",
      flexWrap: "nowrap",
      overflowX: "auto",
    }}
  >
    {children.map(
      (child, i) =>
        child && (
          <div
            key={`minimenu_${i + 100}`}
            className={childClassName}
            style={{ flex: "0 0 auto" }}
          >
            {child}
          </div>
        )
    )}
  </div>
)

export default HorizontalScrollable
